import { render, staticRenderFns } from "./ProfileEditAvatar.vue?vue&type=template&id=e748681c&scoped=true"
import script from "./ProfileEditAvatar.vue?vue&type=script&lang=js"
export * from "./ProfileEditAvatar.vue?vue&type=script&lang=js"
import style0 from "./ProfileEditAvatar.vue?vue&type=style&index=0&id=e748681c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e748681c",
  null
  
)

export default component.exports